import { useRef } from 'react';

const uuidToken = (defaultValue = 1) => {
  const _uuid = useRef(defaultValue);

  return {
    uuid: _uuid.current,
    getNameSpace() {
      return _uuid.current;
    },
    renew() {
      _uuid.current += +1;
      return _uuid.current;
    },
  };
};

export default uuidToken;
